/* ------------------------------------------------------------------ */
/*  @stayframe/ui — Barrel Export                                     */
/*  Graphite + Teal Nordic Design System                              */
/* ------------------------------------------------------------------ */

/* Inject global keyframes once */
import { injectStyles } from "./inject-styles";
injectStyles(
  "sf-global",
  `@keyframes sf-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`,
);

/* Components */
export { Button } from "./Button";
export type { ButtonProps, ButtonVariant, ButtonSize } from "./Button";

export { IconButton } from "./IconButton";
export type { IconButtonProps, IconButtonVariant, IconButtonSize } from "./IconButton";

export { Input } from "./Input";
export type { InputProps } from "./Input";

export { Select } from "./Select";
export type { SelectProps } from "./Select";

export { Textarea } from "./Textarea";
export type { TextareaProps } from "./Textarea";

export { Card } from "./Card";
export type { CardProps } from "./Card";

export {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableHeaderCell,
  TableCell,
} from "./Table";
export type {
  TableProps,
  TableHeadProps,
  TableBodyProps,
  TableRowProps,
  TableHeaderCellProps,
  TableCellProps,
} from "./Table";

export { Badge } from "./Badge";
export type { BadgeProps, BadgeVariant } from "./Badge";

export { StatusPill } from "./StatusPill";
export type { StatusPillProps, StatusPillVariant } from "./StatusPill";

export { Tabs, TabsList, TabsTrigger, TabsPanel } from "./Tabs";
export type {
  TabsProps,
  TabsListProps,
  TabsTriggerProps,
  TabsPanelProps,
} from "./Tabs";

export { ToastProvider, useToast, ToastMessage } from "./Toast";
export type { ToastProviderProps, ToastVariant, ToastData } from "./Toast";

export { Skeleton } from "./Skeleton";
export type { SkeletonProps, SkeletonVariant } from "./Skeleton";

export { EmptyState } from "./EmptyState";
export type { EmptyStateProps } from "./EmptyState";

export { Spinner } from "./Spinner";
export type { SpinnerProps } from "./Spinner";

export { KpiCard } from "./KpiCard";
export type { KpiCardProps } from "./KpiCard";

export { Sparkline } from "./Sparkline";
export type { SparklineProps } from "./Sparkline";

export { DeltaChip } from "./DeltaChip";
export type { DeltaChipProps } from "./DeltaChip";

export { SemanticPanel } from "./SemanticPanel";
export type { SemanticPanelProps, SemanticPanelVariant } from "./SemanticPanel";
